const getPatientLastName = ({ patient, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return patient['Last Name'].toUpperCase();
};

export default getPatientLastName;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientLastName.js